import {
    PageOpts,
    PersistedPPID,
    PPIDUserObject,
} from '../../shared/types/ast';
import { getAdId } from './cookie';
import { getPPID } from './pulse-ppid';
import { displayAdsLog } from './debug';

/**
 * Set pageOpts:
 * PPID in pageOpts.user.userIds and pageOpts.eids (because doc says to set it on userIds, but it only works if you set it
 * directly on eids.
 *
 * Old solution which we need to keep:
 * pageOpts.user.externalUid: adId (which is basically the same as SCHNO-EnvHash (PPID2)
 * pageOpts.user.dnt = do not track
 * @param pageOpts
 */
export function setExternalUid(pageOpts: PageOpts): PageOpts {
    if (pageOpts) {
        const adId = getAdId();
        pageOpts.user = {};
        pageOpts.user.externalUid = adId;

        const doNotTrack =
            adId === 'DO_NOT_TRACK' ||
            (navigator && navigator.doNotTrack === '1');
        pageOpts.user.dnt = doNotTrack;

        try {
            const persistedPPID: PersistedPPID = getPPID();

            if (persistedPPID) {
                // Remove undefined id's
                const extIds = [
                    {
                        source: 'SCHNO-UserHash',
                        id: persistedPPID.ppid1,
                    } as PPIDUserObject,
                    {
                        source: 'SCHNO-EnvHash',
                        id: persistedPPID.ppid2,
                    } as PPIDUserObject,
                ];
                const filteredEids = extIds.filter((d) => Boolean(d.id));

                pageOpts.user.userIds = [
                    {
                        type: 'extendedIDs',
                        eids: filteredEids,
                    },
                ];

                // Also set keywords for v3 request
                const ppidKeywords = {
                    'aa-sch-schuserhash': persistedPPID.ppid1 ? ['1'] : ['0'],
                    'aa-sch-schenvhash': persistedPPID.ppid2 ? ['1'] : ['0'],
                };

                pageOpts.keywords = {
                    ...pageOpts.keywords,
                    ...ppidKeywords,
                };

                displayAdsLog(
                    `pageOpts.user.userIds = ${JSON.stringify(
                        pageOpts.user.userIds,
                    )}`,
                );
            }
        } catch (e) {
            console.error(e);
        }
    }
    return pageOpts;
}
